import { z } from 'zod';
import { ContentTypeSchema } from './schema/commons';
export const AssetSchema = z.object({
    contentType: ContentTypeSchema,
    description: z.string(),
    details: z.object({
        image: z
            .object({
            height: z.number(),
            width: z.number()
        })
            .optional(),
        size: z.number().optional()
    }),
    fileName: z.string(),
    title: z.string(),
    url: z.string()
});
//# sourceMappingURL=asset.js.map